import { render, staticRenderFns } from "./CaptiveFormsModalNavTabs.vue?vue&type=template&id=ad851248&scoped=true"
import script from "./CaptiveFormsModalNavTabs.vue?vue&type=script&lang=js"
export * from "./CaptiveFormsModalNavTabs.vue?vue&type=script&lang=js"
import style0 from "./CaptiveFormsModalNavTabs.vue?vue&type=style&index=0&id=ad851248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad851248",
  null
  
)

export default component.exports